/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Recovery_Code_Instruction_4Inputs */



/**
* | output |
* | --- |
* | "If you lose this code, you may not be able to recover your account" |
*
* @param {Auth_Recovery_Code_Instruction_4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_recovery_code_instruction_4 = /** @type {((inputs?: Auth_Recovery_Code_Instruction_4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Recovery_Code_Instruction_4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wenn du diesen Code verlierst, kannst du möglicherweise nicht auf dein Konto zugreifen")
	return /** @type {LocalizedString} */ ("If you lose this code, you may not be able to recover your account")
});